// https://github.com/ICJIA/vue-browser-detect-plugin/blob/master/src/main.js
const browserDetect = (() => {
  const ua = window.navigator.userAgent;
  let browserObj = {};

  browserObj.isEdge = /Edg/.test(navigator.userAgent);
  browserObj.isIE = /*@cc_on!@*/ false || !!document.documentMode; // Internet Explorer 6-11
  browserObj.ieDocumentMode = document.documentMode;
  browserObj.isChrome = /Google Inc/.test(navigator.vendor) && !browserObj.isEdge;
  browserObj.isIpad = /iPad/.test(navigator.userAgent) && !window.MSStream;
  browserObj.isIphone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
  browserObj.isIOS = browserObj.isIpad || browserObj.isIphone;
  browserObj.isMobile = /mobile/.test(window.location.href);
  browserObj.isAppBuilderTypeByapps = /byapps/.test(navigator.userAgent) && !/GDWebViewApp/.test(navigator.userAgent);
  browserObj.supportsPopState = !browserObj.isAppBuilderTypeByapps;
  browserObj.supportsHistory = window.history && window.history.replaceState;
  browserObj.supportsFixedPosition = (() => {
    if (browserObj.isIE && browserObj.ieDocumentMode <= 7 || typeof browserObjieDocumentMode === undefined) {
      return false;
    }
    const androidAgent = navigator.userAgent.match(/Android ([0-9])\.([0-9])/)
    if (androidAgent && parseFloat(androidAgent[1] + "." + androidAgent[2]) < 4.3) {
      return false;
    }
    return true;
  })();

  return browserObj;
})();

export default browserDetect;
